export class UpdateMovieTitle {
  static readonly type = '[Reservation] Update Movie Title';
  constructor(public movieTitle: string | null, public movieOriginalTitle: string | null) {}
}
